var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "90324d73-5838-4221-982d-f6a287687ffa",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon5",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon5",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/c61d20c8-ce40-4e8f-bd0f-e94515091f3c/db69e5d94bb80ce142942055905bfcbf5c16445a/",
    core: "4.5.1",
    title: "Deco2",
    type: "haiku",
    relpath: "code/deco2/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco2-20cb245cfb651e73": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 11.239,
        "sizeAbsolute.y": 12.089,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:d0eef39a7eb2": {
        "sizeAbsolute.y": 7,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 7,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 5.196000000000001,
        "translation.y": 6.044000000000001,
        "style.zIndex": 3,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284, edited: true }
        }
      },
      "haiku:1ac1e42efef8": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:cd3581fbd652": {
        fill: "#A3CE32",
        "translation.x": -46,
        "translation.y": -1
      },
      "haiku:19775c164591": {
        x: 46.6514216,
        y: 1.15142164,
        width: 5.94212411,
        height: 5.94212411,
        rx: 1,
        "translation.x": 0.28376,
        "translation.y": -2.59139,
        "rotation.z": 0.05236
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco2-20cb245cfb651e73",
      "haiku-title": "Deco2"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "d0eef39a7eb2",
          "haiku-title": "deco2",
          "haiku-source":
            "designs/AnimatorWebsiteIcon5.sketch.contents/slices/deco2.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "1ac1e42efef8",
              "haiku-title": "Page-1",
              id: "fc88fb5fbeef"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "cd3581fbd652",
                  "haiku-title": "Docs-icon",
                  id: "ee576dfe1820"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "19775c164591",
                      "haiku-title": "deco2",
                      id: "0d6d88e8fc0a"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon5/code/deco2/code.js
// module id = 449
// module chunks = 127651196306611